<template>
  <div>
    <section class="default-row category-row" v-show="state.status.isLoading">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <img src="/images/default/spinner-lg.gif" alt="Loading" />
          </div>
        </div>
      </div>
    </section>

    <transition name="fade">
      <div v-show="!state.status.isLoading">
        <div class="container">
          <div class="row">
            <ul class="breadcrumb">
              <li>
                <a href="/">
                  {{ getLabel('_webhome') }}
                </a>
              </li>
              <li class="active">
                {{ state.productsView.Name }}
              </li>
            </ul>
          </div>
        </div>
        <section class="default-row category-row">
          <div class="container">
            <div class="row">
              <div class="col-xs-12">
                <h1 class="section-title">
                  {{ state.productsView.Name }}
                </h1>
              </div>
              <div class="col-md-8 col-xs-12">
                <div class="form-group" v-if="!state.settings.storeSettings.HideOutOfStock">
                  <p>
                    <strong>
                      {{ getLabel('_nbproduct') }}
                      -
                    </strong>
                    {{ productCount }}
                  </p>
                </div>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs">
                <div class="form-group">
                  <div class="pull-right">
                    <label class="label-horizontal">
                      {{ getLabel('web_orderby') }}
                    </label>
                    <select class="input-sm" v-model="state.selectedSortBy">
                      <option v-for="sort in state.sortBy" :value="sort.Id" :key="sort.Id">
                        {{ getLabel(sort.Name) }}
                      </option>
                    </select>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <!-- Empty status-->
                <div class="clearfix"></div>
                <div class="default-row" v-show="!state.status.isFetching && productCount == 0">
                  <div class="alert alert-info">
                    <strong>
                      <span class="glyphicon glyphicon-info-sign"></span>
                      {{ getLabel('_empty') }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2 col-md-3 col-xs-12">
                <section id="filters"
                  :class="{ 'open-filter': state.status.isFilterDisplayed, 'close-filter': !state.status.isFilterDisplayed }"
                  v-click-outside="hideFilter">

                  <div class="form-group filter-toggle">
                    <a href="#hide" @click="toggleFilter($event)">
                      <span class="glyphicon glyphicon glyphicon-menu-hamburger"></span>
                    </a>
                  </div>

                  <applied-filters :filters="appliedFilters">
                  </applied-filters>

                  <tags-groups-filter>
                  </tags-groups-filter>

                  <filters v-bind:title="getLabel('tags')" v-bind:filters="getLooseFilters()">
                  </filters>

                  <filters v-bind:title="getLabel('_format')" v-bind:filters="getFormats()">

                  </filters>
                </section>
              </div>
              <div class="col-lg-10 col-md-9 col-xs-12">
                <div class="default-row" v-show="state.status.isFetching">
                  <img src="/images/default/spinner-lg.gif" alt="Loading" class="img-responsive img-centered" />
                </div>

                <transition name="fade">
                  <div v-show="!state.status.isFetching">
                    <div class="col-lg-4 col-md-6 col-sm-12" v-for="product in state.productsView.Products"
                      :key="product.Id">
                      <product v-bind:product="product" v-bind:settings="state.settings.storeSettings"
                        v-bind:labels="state.labels">
                      </product>
                    </div>
                  </div>
                </transition>

                <!-- Loading adding products -->
                <div class="clearfix"></div>
                <div class="default-row text-center" v-show="state.status.isAdding">
                  <img src="/images/default/spinner-lg.gif" alt="Loading" class="img-responsive img-centered" />
                </div>

                <div class="clearfix"></div>
                <div v-if="!state.status.isFetching && hasMoreItems">
                  <a href="#loadMore" v-on:click="loadMore($event)"
                    v-observe-visibility="state.status.isFirstLoadComplete == true ? loadMoreObserve : false">
                  </a>
                </div>

                <div class="clearfix"></div>
                <div class="default-row text-center">
                  <a id="loadmore" href="#header-banner" class="btn btn-lg top pull-right">
                    <span class="glyphicon glyphicon-arrow-up"></span>
                    {{ getLabel('_webbacktotop') }}
                  </a>

                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="float-filters hidden-md hidden-lg">
          <div class="item">
            <div class="dropup">
              <a class="dropdown-toggle" href="#sortBy" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                {{ getLabel(appliedSortBy.Name) }}
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <li v-for="sort in state.sortBy" :value="sort.Id" :key="sort.Id">
                  <a href="#sort" @click="setSortBy(sort.Id, $event)">
                    {{ getLabel(sort.Name) }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="item">
            <a id="show-filter" href="#filter" @click="toggleFilter($event)">
              {{ getLabel('filter') }}
              <span v-show="hasAppliedFilters">
                ({{ numberOfAppliedFilters }})
              </span>
            </a>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Vue from 'vue'

import { store } from './store.js';
import { shared } from './shared.js';
import tagsFilter from './components/tagGroupsFilter.vue';
import filters from './components/filters.vue';
import appliedFilters from './components/appliedFilters.vue';
import product from './components/product.vue';
import vueLazy from 'vue-lazyload'

Vue.use(vueLazy, {
  // set observer to true
  observer: true,

  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
});

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    window.event = function (event) {
      if (!(el == event.target || el.contains(event.target) || event.target.id == 'show-filter')) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', window.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', window.event)
  }
});

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

export default {
  name: 'HomeView',
  created: function () {
    store.init(function () {
      Vue.nextTick(function () {
        AdjustCardSize();
      });
    });
  },  
  mixins: [shared],
  data: function () {
    return {
      state: store.state
    }
  },
  components: {
    'tags-groups-filter': tagsFilter,
    'filters': filters,
    'product': product,
    'applied-filters': appliedFilters
  },
  methods: {
    getLooseFilters: function () {
      var filters = store.getLooseFilters();
      return filters;
    },
    getCategories: function () {
      var filters = store.getFiltersByType('category');
      return filters;
    },
    getFormats: function () {
      var filters = store.getFiltersByType('format');
      return filters;
    },
    setSortBy: function (id, event) {
      event.preventDefault();
      store.setSortBy(id);
    },
    toggleFilter: function (event) {
      event.preventDefault();
      store.toggleFilter();
    },
    hideFilter: function () {
      store.hideFilter();
    },
    loadMoreObserve: function () {
      store.loadMore();
    },
    loadMore: function (e) {
      e.preventDefault();
      store.loadMore();
    }
  },
  computed: {
    hasAppliedFilters: function () {
      var filters = store.getAppliedFilters();
      return filters.length > 0 ? true : false;
    },
    numberOfAppliedFilters: function () {
      var filters = store.getAppliedFilters();
      return filters.length;
    },
    appliedFilters: function () {
      var filters = store.getAppliedFilters();
      return filters;
    },
    appliedSortBy: function () {
      var sortBy = store.getAppliedSortBy();
      return sortBy;
    },
    productCount: function () {
      var productCount = store.getCategoryProductCount();
      return productCount;
    },
    hasMoreItems: function () {
      return this.state.productsView.Products.length < this.state.productsView.ProductCount;
    }
  },
  watch: {
    'state.selectedSortBy': function () {
      store.filter();
    }
  }
}
</script>